/* projects/shared/layouts/responsive-nav-bar/shared-sidebar-list-responsive/shared-sidebar-list-responsive.component.scss */
shared-sidebar-list-responsive.side shared-sidebar-item,
shared-sidebar-list-responsive.full-screen shared-sidebar-item {
  box-sizing: border-box;
}
shared-sidebar-list-responsive.side shared-sidebar-item nv-icon,
shared-sidebar-list-responsive.full-screen shared-sidebar-item nv-icon {
  height: 100%;
  width: 100%;
}
shared-sidebar-list-responsive.side shared-sidebar-item .shared-sidebar-item,
shared-sidebar-list-responsive.full-screen shared-sidebar-item .shared-sidebar-item {
  color: var(--color-white);
  background-color: var(--color-blue);
  border-radius: unset;
}
shared-sidebar-list-responsive.side shared-sidebar-item .shared-sidebar-item:hover,
shared-sidebar-list-responsive.side shared-sidebar-item .shared-sidebar-item:focus,
shared-sidebar-list-responsive.full-screen shared-sidebar-item .shared-sidebar-item:hover,
shared-sidebar-list-responsive.full-screen shared-sidebar-item .shared-sidebar-item:focus {
  color: var(--color-white);
  background-color: var(--color-blue-dark-5);
  outline-color: var(--color-blue-dark-5);
  border-radius: unset;
}
shared-sidebar-list-responsive.side shared-sidebar-item .shared-sidebar-item.selected,
shared-sidebar-list-responsive.full-screen shared-sidebar-item .shared-sidebar-item.selected {
  color: var(--color-white);
  background-color: var(--color-blue-dark-7);
  border-radius: unset;
}
shared-sidebar-list-responsive.side shared-sidebar-item .shared-sidebar-item .sidebar-item-label,
shared-sidebar-list-responsive.side shared-sidebar-item .shared-sidebar-item .sidebar-item-icon,
shared-sidebar-list-responsive.full-screen shared-sidebar-item .shared-sidebar-item .sidebar-item-label,
shared-sidebar-list-responsive.full-screen shared-sidebar-item .shared-sidebar-item .sidebar-item-icon {
  padding: unset;
}
shared-sidebar-list-responsive.side .mat-tree .mat-tree-node {
  width: var(--responsive-navbar-on-the-side-item-width);
  height: var(--responsive-navbar-on-the-side-item-height);
}
shared-sidebar-list-responsive.side shared-sidebar-item {
  width: var(--responsive-navbar-on-the-side-item-width);
  height: var(--responsive-navbar-on-the-side-item-height);
}
shared-sidebar-list-responsive.side shared-sidebar-item .shared-sidebar-item {
  display: grid;
  grid-template-rows: var(--space-xxxl) var(--font-xs);
  grid-template-columns: unset;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: var(--font-xs);
  padding: 12px 0;
  grid-gap: var(--space-xxs);
  gap: 5px;
}
shared-sidebar-list-responsive.full-screen .mat-tree .mat-tree-node {
  width: 100%;
  height: var(--responsive-navbar-full-screen-item-height);
}
shared-sidebar-list-responsive.full-screen shared-sidebar-item {
  width: 100%;
  height: var(--responsive-navbar-full-screen-item-height);
}
shared-sidebar-list-responsive.full-screen shared-sidebar-item .shared-sidebar-item {
  display: grid;
  grid-template-rows: unset;
  grid-template-columns: var(--space-xxl) 1fr auto;
  grid-gap: var(--space-m);
  padding: 0 var(--space-xl);
}
shared-sidebar-list-responsive.full-screen shared-sidebar-item .shared-sidebar-item .sidebar-item-label {
  font-size: var(--font-m);
}
/*# sourceMappingURL=shared-sidebar-list-responsive.component-C5RKXZYM.css.map */
